export type OptionType = {
  id: string;
  value: string;
};

type BaseEntityType = {
  id: string;
  value?: string;
  name?: string;
} & ({ value: string } | { name: string }); // Ensure at least one exists

type EntityFieldNamesType<T extends BaseEntityType> = keyof T;

const toOption =
  <T extends BaseEntityType>(valueField: EntityFieldNamesType<T>) =>
  (entity: T): OptionType => ({
    id: entity.id,
    value: String(entity[valueField]),
  });

export const extractFormData = <T extends BaseEntityType>(
  data: T[],
  valueField: EntityFieldNamesType<T> = 'name' as EntityFieldNamesType<T>,
) => (data ? data.map(toOption(valueField)) : []);
